/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import _ from 'lodash';
import { Autocomplete } from '@mui/material';
import React, { useState, useEffect } from 'react';
import CompanyList from './CompanyList';
import EmployeeList from './EmployeeList';
import Reporter from './Reporter';
import { useTranslation } from 'react-i18next';
import Compdirection from '../../Common/CompDirection';
import { CustomToast } from '../../../common/Methodcommon';
import { SearchInput, Button as TailwindButton } from '../../../components';
import orgStructure from '../../../api/orgStructure';

const styles = {
  card1: {
    width: '100%',
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: 1,
  },
  cardTitle: {
    color: '#7C0E6F',
    fontWeight: 'bold',
    fontSize: '18px',
  },
  innerCardTitle: {
    color: '#7C0E6F',
    fontWeight: 'bold',
    fontSize: '14px',
  },
  subheader: {
    color: '#92929D',
    fontWeight: 'bold',

    fontSize: '10px',
  },
  subheader2: {
    color: '#92929D',

    fontSize: '10px',
  },
  content: {
    padding: '1em',
    width: '100%',
  },
  card2: {
    width: '100%',
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: 1,
  },
  box: {
    backgroundColor: 'white',
    borderRadius: '0.8em',
    border: '1px solid #0000001F',
    padding: '1em',
    marginRight: '1em',
    height: '520px',
  },
  action: {
    color: '#464545',
    backgroundColor: '#fafafa',
  },
  left: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
  },
  right: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
  },
  btnAll: {
    fontSize: '0.6em',
    color: '#21D8A5',
    border: '1px solid #21D8A5',
    borderRadius: '5px',
    '&:hover': {
      backgroundColor: 'white',
      boxShadow: 'none',
    },

    '&:focus': {
      backgroundColor: 'white',
    },
  },
  box4: {
    padding: '1em',
  },
  actionArea: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    display: 'flex',
    padding: 1,
    flexDirection: 'row',
  },
  alignLeft: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    display: 'flex',
  },
  alignRigt: {
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    display: 'flex',
  },
  save: {
    boxShadow: 'none',
    textTransform: 'capitalize',
    fontSize: 14,
    color: 'white',
    padding: '6px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#7C0E6F',

    borderRadius: '0.5em',
    height: '42px',
    width: '120px',
    '&:hover': {
      backgroundColor: '#7C0E6F',
      boxShadow: 'none',
    },
    '&:active': {
      backgroundColor: '#7C0E6F',
    },
    '&:disabled': {
      backgroundColor: '#f5f5f5',
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
  cancel: {
    boxShadow: 'none',
    textTransform: 'capitalize',
    fontSize: 14,
    color: '#FF5263',
    padding: '6px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#FFEDEF',

    borderRadius: '0.5em',
    height: '42px',
    width: '120px',
    '&:hover': {
      backgroundColor: '#FFEDEF',
      boxShadow: 'none',
    },
    '&:active': {
      backgroundColor: '#FFEDEF',
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
};

// fromOnboarding: when true, the "Select Employees" card is hidden — this
// flow already knows exactly who it's assigning (the single employee just
// onboarded), so there's nothing to search/pick from a list. empId is
// seeded directly into selectedEmployees instead, bypassing EmployeeList
// entirely for this case.
const NewReportingStructure = (props) => {
  const { t, i18n } = useTranslation();
  const fromOnboarding = !!props.fromOnboarding;

  const [selectedBU, setSelectedBU] = useState(undefined);
  const [isDirect, setIsDirect] = useState(false);
  const [selectedBUName, setSelectedBUName] = useState('');
  const [currentRoleBU, setCurrentRoleBU] = useState({});
  const [, setCurrentSelectedRole] = useState({});
  const [, setRoleValue] = useState(props.rolesForBU[0]);
  const [currentManager, setCurrentManager] = useState(undefined);
  // Seeded directly with props.empId when fromOnboarding — no employee
  // picker interaction happens in that case, so this is set once up front
  // rather than via handleEmployeeSelect.
  const [selectedEmployees, setSelectedEmployees] = useState(
    fromOnboarding && props.empId ? [props.empId] : [],
  );
  const [companyList, setCompanyList] = useState([]);
  const [btnText, setBtnText] = useState('Select All');
  const [employees, setEmployees] = useState([]);
  const [skip, setSkip] = useState(1);
  const [limit] = useState(100);
  const [hasMore, setHasMore] = useState(true);
  const [employeeCount, setEmployeeCount] = useState(0);
  const [ids, setIds] = useState([]);

  const handleBUSelection = (id, name) => {
    setSelectedBU(id);
    setSelectedBUName(name);
    props.onRoleBUSelect(id);
    props.onBUSelect(id);
    setCurrentRoleBU(id);
    setCurrentSelectedRole({});
    setEmployeeCount(0);
    getEmployeeIds(id);
  };
  let currentSelectedEmps = [];

  const getEmployeeIds = (id) => {
    orgStructure.getEmployeesIdsByCompanyId(id).then((res) => {
      setIds(res);
    });
  };
  const handleSearch = (val) => {
    orgStructure
      .getEmployeesByCompanyIdAndLanguage(selectedBU, i18n.language, val)
      .then((res) => {
        if (res) {
          setEmployees(res);
        }
      })
      .catch((err) => console.log(err));
  };

  const fetchData = () => {
    orgStructure
      .getEmployeesByCompanyIdAndLanguage(
        selectedBU,
        i18n.language,
        null,
        skip,
        limit,
      )
      .then((res) => {
        if (res) {
          setEmployees((prevEmployees) => [...prevEmployees, ...res]);
          setSkip((prevState) => prevState + 1);
          if (res.length < limit) {
            setSkip(1);
            setHasMore(false);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setEmployees(props.employees);
    setHasMore(true);
    if (!employeeCount && selectedBU) {
      orgStructure.getEmployeesCountByCompanyId(selectedBU).then((res) => {
        setEmployeeCount(res);
      });
    }
  }, [props.employees]);

  const handleRole = (role) => {
    setCurrentSelectedRole(role);
    setRoleValue(role);
    setIsDirect(role?.SequenceName ? true : false);
    props.onRoleSelect(selectedBU, role.id);
  };

  const handleReporterSelect = (manager) => {
    setCurrentManager(manager);
  };

  const handleAssign = () => {
    if (selectedEmployees.length <= 0) {
      if (currentSelectedEmps.length === 0)
        return CustomToast('error', t('Please select atleast one reportee'));
    }
    if (!currentRoleBU) {
      return CustomToast('error', t('Please choose a BU to start with'));
    }
    if (!currentManager) {
      return CustomToast(
        'error',
        t('Please choose atleast on reporting manager'),
      );
    }
    const s = {
      userIds: selectedEmployees,
      companyId: selectedBU,
      userRoleId: currentManager,
      isDirect: isDirect,
    };
    if (props.pageFrom === 'faceReportStructure') {
      s.pageFrom = props.pageFrom;
    }
    props.onHandleAssignee(s);
    props.onCancel();
  };

  const handleEmployeeSelect = (selected) => {
    setSelectedEmployees(selected);
    currentSelectedEmps = selected;
  };

  const handleSelectAll = () => {
    if (btnText === 'Select All') {
      setBtnText('Unselect All');
    } else {
      setBtnText('Select All');
    }
  };

  useEffect(() => {
    const list = _.unionBy(props.companies, 'companyId');
    setCompanyList(list);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={4} direction={'row'}>
      <Grid item xs={fromOnboarding ? 6 : 8}>
        <Card elevation={0} style={styles.card1}>
          <CardHeader
            title={
              <Typography style={styles.cardTitle}>
                {fromOnboarding
                  ? t('Select Company')
                  : t('Select Company & Employees')}
              </Typography>
            }
          />
          <Divider style={{ backgroundColor: '#f5f5f5' }} />
          <CardContent>
            <Grid container spacing={2} direction={'row'}>
              <Grid item xs={fromOnboarding ? 12 : 6}>
                <Box style={styles.box}>
                  <Card elevation={0}>
                    <CardHeader
                      title={
                        <Typography style={styles.innerCardTitle}>
                          {t('Select Company')}
                        </Typography>
                      }
                      subheader={
                        <Typography style={styles.subheader2}>
                          {t('Selectedicon')} {selectedBUName}
                        </Typography>
                      }
                    />
                    <CardContent style={styles.content}>
                      <CompanyList
                        key={companyList.length}
                        companies={companyList}
                        onSelect={handleBUSelection}
                      />
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
              {/**
               * Selection of Employees Grid — hidden entirely when
               * fromOnboarding, since the employee is already known
               * (props.empId, seeded into selectedEmployees above).
               */}
              {!fromOnboarding && (
                <Grid item xs={6}>
                  <Box style={styles.box}>
                    <Card elevation={0}>
                      <CardHeader
                        title={
                          <Typography style={styles.innerCardTitle}>
                            {t('Select Employees')}
                          </Typography>
                        }
                        subheader={
                          <Typography style={styles.subheader2}>
                            {t(`{{count1}}/{{count2}} selected`, {
                              count1: selectedEmployees.length,
                              count2: employeeCount,
                            })}
                          </Typography>
                        }
                      />
                      <CardContent style={styles.content}>
                        <SearchInput
                          placeholder={t('Search Employee')}
                          className="w-[19.2rem]"
                          onChange={(e) => handleSearch(e.target.value)}
                        />
                        {props.isEmployeeLoaded ? (
                          <>
                            {props.employees.length > 0 && (
                              <TailwindButton
                                className="outline-btn gap-x-1 !px-2 my-5 !py-0.5 rtl:text-[10px] border-green-500 text-green-500"
                                onClick={handleSelectAll}
                              >
                                <i className="las la-check-double"></i>
                                {t(btnText)}
                              </TailwindButton>
                            )}

                            <EmployeeList
                              employees={employees}
                              onSelect={handleEmployeeSelect}
                              fetching={fetchData}
                              action={btnText}
                              hasmore={hasMore}
                              key={btnText}
                              ids={ids}
                            />
                          </>
                        ) : (
                          <h3 className="text-center py-10">Loading...</h3>
                        )}
                      </CardContent>
                    </Card>
                  </Box>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={fromOnboarding ? 6 : 4}>
        <Card elevation={0} style={styles.card2}>
          <CardHeader
            title={
              <Typography style={styles.cardTitle}>
                {t('Select Reporting Managers')}
              </Typography>
            }
          />
          <Divider style={{ backgroundColor: '#f5f5f5' }} />
          <CardContent style={styles.content}>
            <Box style={styles.box4}>
              <Compdirection>
                <Autocomplete
                  disabled={!props.rolesForBU.length}
                  options={props.rolesForBU}
                  getOptionLabel={(option) =>
                    option.SequenceName
                      ? `${option.name} (${option.SequenceName})`
                      : option.name
                  }
                  autoHighlight
                  fullWidth
                  onChange={(event, newValue) => {
                    handleRole(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      className="custom-rtl"
                      {...params}
                      label={t('Choose Role')}
                    />
                  )}
                />
              </Compdirection>
            </Box>
            <Reporter
              managers={props.managers}
              BU={currentRoleBU.name}
              onSelect={handleReporterSelect}
            />
            <div className="flex justify-between w-full px-5">
              <TailwindButton className="outline-btn" onClick={props.onCancel}>
                {t('Cancel')}
              </TailwindButton>
              <TailwindButton className="primary-btn" onClick={handleAssign}>
                {t('Assign')}
              </TailwindButton>
            </div>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default NewReportingStructure;